import type React from "react";

import styled from "styled-components";

import { DropInCallIndicator } from "shared/NavBar/components/DropInCallPane/DropInCallIndicator";
import { Hamburger } from "shared/NavBar/components/Hamburger";

interface Props {
  isMobileNavigationOpen: boolean;
  setIsMobileNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MobileTopBar: React.FC<Props> = ({ isMobileNavigationOpen, setIsMobileNavigationOpen }) => {
  return (
    <>
      {isMobileNavigationOpen && (
        <Overlay
          onClick={event => {
            event.stopPropagation();
            setIsMobileNavigationOpen(false);
          }}
        />
      )}
      <TopBar data-testid="top-bar">
        <TopBarItem>
          <IconButton
            onClick={event => {
              event.stopPropagation();
              setIsMobileNavigationOpen(true);
            }}
          >
            <Hamburger open={isMobileNavigationOpen} />
          </IconButton>
        </TopBarItem>
        <DropInCallIndicator
          onClick={event => {
            event.stopPropagation();
            setIsMobileNavigationOpen(true);
          }}
        />
      </TopBar>
    </>
  );
};

const TopBarBase = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 40px;
  border-radius: 35px;
`;

const TopBar = styled(TopBarBase)`
  ${props => props.theme.aboveBreakpoint} {
    display: none;
  }
  position: fixed;
  z-index: ${props => props.theme.semantic.zIndex.navbar};
  margin: 8px;
  box-shadow: 0px 10px 20px rgba(141, 155, 173, 0.3);
`;

const TopBarItem = styled(TopBarBase)`
  z-index: 1;
`;

const Overlay = styled.div`
  position: fixed;
  z-index: 98;
  background: rgba(56, 74, 95, 0.35);
  backdrop-filter: blur(2px);
  width: 100%;
  height: 100%;
`;

const IconButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  &:hover {
    opacity: 0.7;
  }
`;
